export default __webpack_public_path__ + "static/vtex-51b26a5080d24095611563e4588928ae.png";